export const LEFT_COLUMN_WIDTH = 36
export const RIGHT_COLUMN_WIDTH = 48
export const VOICE_INPUT_BORDER_COLOR = '#1565C0'
